import {$win} from '../app/globals';
const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );
		const $accordionItems = $sectionInstance.find( '.js-accordion-item' );

		$accordionItems.each( function() {
			const $accordionItem = $( this );
			const $accordionItemBtn = $accordionItem.find( '.js-accordion-toggler' );
			const $accordionItemContent = $accordionItem.find( '.accordion-item__content' );
			const $accordionItemContentWrapper = $accordionItem.find( '.accordion-item__body' );

			$accordionItemBtn.on( 'click', function() {
				if ( $accordionItem.hasClass( 'open' ) ) {
					$accordionItem.removeClass( 'open' );
					$accordionItemContentWrapper.removeAttr( 'style' );
				} else {
					$accordionItems.removeClass( 'open' );
					$accordionItems.find( '.accordion-item__body' ).removeAttr( 'style' );
					const maxHeight = $accordionItemContent.outerHeight();
					$accordionItem.addClass( 'open' );
					$accordionItemContentWrapper.css( 'max-height', maxHeight );
				}
			} );
		} );

		$win.on( 'resize', function() {
			$accordionItems.filter( '.open' ).each( function() {
				const $openItem = $( this );
				const maxHeight = $openItem.find( '.accordion-item__content' ).outerHeight();
				$openItem.find( '.accordion-item__body' ).css( 'max-height', maxHeight );
			} );
		} );
	} );
};

app.loadBlock( initBlock, 'faq', '.section-faq' );

if ( module.hot ) {
	module.hot.accept();
}
